import { Drawer, TextField, Button, Typography, Box, CircularProgress, Autocomplete } from '@mui/material';
import { useState, useEffect } from 'react';
import { fetchSpaCategories } from '../../api/spaApi';

export default function SpaMenuFormModal({ open, onClose, initialData, onSubmit, propertyId }) {
  const [form, setForm] = useState({
    typeOfMassage: '',
    description: '',
    category: '',
    prices: {}
  });

  const [newDuration, setNewDuration] = useState('');
  const [newPrice, setNewPrice] = useState('');
  const [saving, setSaving] = useState(false);
  const [categorySuggestions, setCategorySuggestions] = useState([]);

useEffect(() => {
  if (open) {
    setForm({
      typeOfMassage: initialData?.typeOfMassage || '',
      description: initialData?.description || '',
      category: initialData?.category || '',
      prices: initialData?.prices || {}
    });
  }
}, [initialData, open]);

useEffect(() => {
  console.log('🔍 Fetching categories for propertyId:', propertyId);
  if (!propertyId) return;
  fetchSpaCategories(propertyId)
    .then(data => {
      console.log('🎯 Categories fetched:', data);
      setCategorySuggestions(data);
    })
    .catch((err) => console.error('Failed to fetch categories', err));
}, [propertyId]);

  const addPrice = () => {
    if (!newDuration || !newPrice) return;
    setForm(prev => ({
      ...prev,
      prices: { ...prev.prices, [newDuration]: parseFloat(newPrice) }
    }));
    setNewDuration('');
    setNewPrice('');
  };

  const removePrice = (duration) => {
    const updatedPrices = { ...form.prices };
    delete updatedPrices[duration];
    setForm(prev => ({ ...prev, prices: updatedPrices }));
  };

  const handleSave = async () => {
    setSaving(true);
    await onSubmit(form);
    setSaving(false);
    onClose();
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: 500 } }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">{initialData ? 'Edit' : 'Add'} Treatment</Typography>

        <TextField
          fullWidth
          label="Type of Massage"
          margin="normal"
          value={form.typeOfMassage}
          onChange={(e) => setForm(prev => ({ ...prev, typeOfMassage: e.target.value }))}
        />

        <TextField
          fullWidth
          label="Description"
          margin="normal"
          value={form.description}
          onChange={(e) => setForm(prev => ({ ...prev, description: e.target.value }))}
        />

        <Autocomplete
          freeSolo
          openOnFocus
          options={categorySuggestions}
          value={form.category || ''}
          onInputChange={(e, newValue) => {
            setForm(prev => ({ ...prev, category: newValue }));
          }}
          renderInput={(params) => (
            <TextField {...params} label="Category" margin="normal" fullWidth />
          )}
        />

        <Box mt={2}>
          <Typography variant="subtitle1" fontWeight="bold">Prices</Typography>
          {Object.entries(form.prices).map(([duration, price]) => (
            <Box key={duration} display="flex" gap={2} mt={1} alignItems="center">
              <Typography>{duration} min</Typography>
              <Typography>${price}</Typography>
              <Button size="small" color="error" onClick={() => removePrice(duration)}>✕</Button>
            </Box>
          ))}

          <Box display="flex" gap={2} mt={2} alignItems="center">
            <TextField
              label="Duration (min)"
              value={newDuration}
              onChange={(e) => setNewDuration(e.target.value)}
              type="number"
              size="small"
            />
            <TextField
              label="Price"
              value={newPrice}
              onChange={(e) => setNewPrice(e.target.value)}
              type="number"
              size="small"
            />
            <Button variant="outlined" size="small" onClick={addPrice}>Add</Button>
          </Box>
        </Box>

        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            sx={{ ml: 2 }}
            onClick={handleSave}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {initialData ? 'Update' : 'Save'}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
